import { render } from "./pickup-corporate-address-section.vue?vue&type=template&id=bef1c1e4&ts=true"
import script from "./pickup-corporate-address-section.vue?vue&type=script&lang=ts"
export * from "./pickup-corporate-address-section.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__